import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=5260f564"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=5260f564&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5260f564')) {
      api.createRecord('5260f564', component.options)
    } else {
      api.reload('5260f564', component.options)
    }
    module.hot.accept("./messageDetail.vue?vue&type=template&id=5260f564", function () {
      api.rerender('5260f564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/handoverException/component/messageDetail.vue"
export default component.exports